import { Text } from '@qga/roo-ui/components';

import { getItemRangeForPage } from '../utils';

export interface ItemCountProps {
  currentPage: number;
  itemName: string | undefined;
  itemsPerPage: number | undefined;
  numItems: number | undefined;
}

const ItemCount = ({
  itemName = 'items',
  itemsPerPage,
  numItems,
  currentPage,
}: ItemCountProps) => {
  if (!itemsPerPage || !numItems) {
    return null;
  }

  const [startRange, endRange] = getItemRangeForPage({
    itemsPerPage,
    numItems,
    currentPage,
  });

  return (
    <Text data-testid="pagination-item-count" my={4} fontSize="sm">
      Showing {startRange}-{endRange} of {numItems} {itemName}
    </Text>
  );
};

export default ItemCount;
